import React from 'react';

interface IProps {
  label: React.ReactNode;
}

const TabLabel: React.FC<IProps> = (props) => {
  const { label } = props;

  return <div>{label}</div>;
};

export default TabLabel;
